export default __webpack_public_path__ + "static/media/put_piece.5ab3c162.mp3";